import React, { useState, useEffect } from "react";
import "../../assets/css/video-mundial.css";

const VideoMundialComponent: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className="video-mundial-section">
      <div className="video-mundial-container">

        <h2 className="video-mundial-title">
          ¿Te imaginas estar en<br />la Copa Mundial de la FIFA 2026™?
        </h2>

        <div className={`video-mundial-wrapper ${isMobile ? "video-vertical" : "video-horizontal"}`}>
          {isMobile ? (
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/mCTG9KxXv_M?si=4GPlQNXBd6Zs_JI6&autoplay=1&mute=0&loop=1&playlist=mCTG9KxXv_M"
              title="Hyundai Video Vertical"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/auE7BdrVhGA?si=iUFMtkxHv_AqJ6rf&autoplay=1&mute=0&loop=1&playlist=auE7BdrVhGA"
              title="Hyundai Video Horizontal"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          )}
        </div>

      </div>
    </section>
  );
};

export default VideoMundialComponent;
